export enum EMeliStatus {
  IN_PROGRESS = "in_progress",
  FINISHED = "finished",
}
